<script>
    // @ts-nocheck
    import { createEventDispatcher } from "svelte";

    /**
     * @type {string | undefined}
     */
    export let styleType = 'fill';
    /**
     * @type {string | undefined}
     */
    export let tag = 'a';
    export let href = '#';
    export let rel = undefined;
    export let target = undefined;
    export let hover = 'var(--color-bg-0)';
    
    const dispatch = createEventDispatcher();
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<svelte:element 
    this={tag} 
    class="btn {styleType}"
    href={tag == 'a' ? href : undefined}
    {rel}
    {target}
    style:--hover={hover}
    on:click={()=>{dispatch('click')}}
>
    <slot></slot>
</svelte:element>

<!-- <style lang="postcss">
    .btn{
        font-family: var(--font-light);
        transition: .15s ease-out;
        transition:
            color .15s ease-out,
            background .15s ease-out,
            border-color .15s ease-out,
        ;
        padding: 0.5833rem 1.6667rem;
        border-radius: 0.17rem;
        display: inline-block;
        cursor: pointer;

        &.fill{
            font-size: inherit;
            background: var(--color-bg-0);
            border: 1px solid var(--color, #000);
            color: var(--color, #000);
            box-shadow: 0.17rem 0.17rem 0 0 var(--color, #000); 

            &:hover{
                background: var(--hover);
                box-shadow: 0 0 0 0 var(--color, #000); 
            }
        }
        &.border{
            font-size: inherit;
            background: var(--onColor, transparrent);
            border: 1px solid var(--color, currentColor);
            color: var(--color, currentColor);

            &:hover{
                color: var(--onColor, var(--color-text))!important;
                background: var(--color, var(--color-bg-0))!important;
            }
        }
        &.hover-text-invert:hover{
            color: var(--color-bg-0);
        }
    }
</style> -->